module.exports = __webpack_public_path__ + "img/finish-zh.8cbdcc1f.png";